import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import ConditionTemplate from './ConditionTemplate'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import { lang } from '../../assets/lang'

const instagram_addon = window.xitFlowBuilderData.instagram_addon
var recurring_notification_addon = window.xitFlowBuilderData.recurring_notification_addon
var instagram_recurring_notification_addon = window.xitFlowBuilderData.instagram_recurring_notification_addon

var recurring_notification_display = 0;
if(!instagram_addon && recurring_notification_addon)
  recurring_notification_display = 1;
if(instagram_addon && instagram_recurring_notification_addon)
  recurring_notification_display = 1;

export default class ConditionComponent extends Rete.Component {
  constructor (config) {
    super(CONST_COMPONENT.CONDITION)
    
    this.data.component = ConditionTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.is_openai_addon_access = !!window.xitFlowBuilderData.is_openai_addon_access
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder (node) {
    node.lingualName = lingualName.CONDITION
    this.setConnection()

    const conditionInput = new Rete.Input(CONST_SOCKET.CONDITION_INPUT, lang.condition_socket_input_reply, this.socket.conditionInput, true)
    const conditionOutputTrue = new Rete.Output(CONST_SOCKET.CONDITION_OUTPUT_TRUE, lang.condition_socket_output_true, this.socket.conditionOutputTrue, false)
    const conditionOutputFalse = new Rete.Output(CONST_SOCKET.CONDITION_OUTPUT_FALSE, lang.condition_socket_output_false, this.socket.conditionOutputFalse, false)

    return node
      .addInput(conditionInput)
      .addOutput(conditionOutputTrue)
      .addOutput(conditionOutputFalse)
  }

  // eslint-disable-next-line
  worker (node, inputs, outputs) {
    outputs[CONST_SOCKET.CONDITION_OUTPUT] = node.data
  }

  setConnection () {
    // Condition may take connections from:
    this.socket.conditionInput.combineWith(this.socket.referenceOutput)
    this.socket.conditionInput.combineWith(this.socket.newPostbackOutput)

    // ConditionTrue may be connected to:
    this.socket.conditionOutputTrue.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.conditionOutputTrue.combineWith(this.socket.openaiInput)
    this.socket.conditionOutputTrue.combineWith(this.socket.carouselInput)
    this.socket.conditionOutputTrue.combineWith(this.socket.imageInput)
    this.socket.conditionOutputTrue.combineWith(this.socket.videoInput)
    this.socket.conditionOutputTrue.combineWith(this.socket.audioInput)
    
    if (!this.isInstagramAddonAvailable) {
      this.socket.conditionOutputTrue.combineWith(this.socket.facebookMediaInput)
      this.socket.conditionOutputTrue.combineWith(this.socket.fileInput)
    }

    if (recurring_notification_display)
      this.socket.conditionOutputTrue.combineWith(this.socket.rcnInput)
    
    
    this.socket.conditionOutputTrue.combineWith(this.socket.ecommerceInput)
    this.socket.conditionOutputTrue.combineWith(this.socket.genericTemplateInput)
    this.socket.conditionOutputTrue.combineWith(this.socket.componentListInput)

    if(this.http_api_module)
    {
      this.socket.conditionOutputTrue.combineWith(this.socket.httpApiInput)
    }
    
    if (this.isUserInputFlowAddonAvailable) {
      this.socket.conditionOutputTrue.combineWith(this.socket.userInputFlowInput)
    }
    
    // ConditionFalse may be connected to:
    this.socket.conditionOutputFalse.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
    this.socket.conditionOutputFalse.combineWith(this.socket.openaiInput)
    
    this.socket.conditionOutputFalse.combineWith(this.socket.carouselInput)
    this.socket.conditionOutputFalse.combineWith(this.socket.imageInput)
    this.socket.conditionOutputFalse.combineWith(this.socket.videoInput)
    this.socket.conditionOutputFalse.combineWith(this.socket.audioInput)
    
    if (!this.isInstagramAddonAvailable) {
      this.socket.conditionOutputFalse.combineWith(this.socket.facebookMediaInput)
      this.socket.conditionOutputFalse.combineWith(this.socket.fileInput)
      // this.socket.conditionOutputFalse.combineWith(this.socket.otnInput)
    }
    
    if (recurring_notification_display)
      this.socket.conditionOutputFalse.combineWith(this.socket.rcnInput)

    this.socket.conditionOutputFalse.combineWith(this.socket.ecommerceInput)
    this.socket.conditionOutputFalse.combineWith(this.socket.genericTemplateInput)
    this.socket.conditionOutputFalse.combineWith(this.socket.componentListInput)

    if(this.http_api_module)
    {
      this.socket.conditionOutputFalse.combineWith(this.socket.httpApiInput)
    }

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.conditionOutputFalse.combineWith(this.socket.userInputFlowInput)
    }
  }
}